import { Footer as VuiFooter } from '@veracity/vui'

const Footer = () => <VuiFooter />

export default Footer
